import { TChatMessage } from '~/features/chatbot/models'
import { EServerPath } from '~/models/api'

const queryKeys = {
  chat: () => [EServerPath.chat],
  chatbotSettingsByLegacyChatbotId: (legacyChatbotId: string) => [
    EServerPath.chatbotSettings,
    { legacyChatbotId },
  ],
}

export function shouldActivateButton(
  aiResponse: string,
  assistantMessages: TChatMessage[],
) {
  const phrasesToActivateBookAMeetingBtn = [
    'calendly',
    'schedule a meeting',
    'book a meeting',
    'set up a meeting',
    'reserve a meeting',
  ]
  const lowerCaseResponse = aiResponse.toLowerCase()
  const foundInAiResponse = phrasesToActivateBookAMeetingBtn.some((phrase) =>
    lowerCaseResponse.includes(phrase.toLowerCase()),
  )

  if (foundInAiResponse) {
    return true
  }

  const foundInAssistantMessages = assistantMessages.some((messageObj) =>
    phrasesToActivateBookAMeetingBtn.some((phrase) =>
      messageObj.message.toLowerCase().includes(phrase.toLowerCase()),
    ),
  )

  return foundInAssistantMessages
}

export default queryKeys
